import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';
import { BallTriangle } from 'react-loader-spinner';
import { MagnifyingGlass } from 'react-loader-spinner'






const Standings = () => {


    const teamName = document.querySelector('.placename')
    const [data, setData] = useState([]);
    const [selectedLeague, setSelectedLeague] = useState('39');
    const [selectedYear, setSelectedYear] = useState('2023');
    const [loading, setLoading] = useState(true);
    const [noData, setNoData] = useState(false);






    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const options = {
                method: 'GET',
                url: 'https://api-football-v1.p.rapidapi.com/v3/standings',
                params: {
                    season: `${selectedYear}`,
                    league: `${selectedLeague}`,
                },
                headers: {
                    'X-RapidAPI-Key': '3a1f5c1448msh76651723dbbc972p1224a1jsn4f654d29b46a',
                    'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com',
                },
            };

            try {
                const response = await axios.request(options);
                setData(response.data.response[0].league);
                setLoading(false);
                setNoData(false)
           
            } catch (error) {
                console.error(error);
                setLoading(false)
                setNoData(true)
            }
        };

        fetchData();
    }, [selectedLeague,selectedYear]);

    return (
        <div className='standings-container'>
            {noData ? (
                <div className='noDataWrapper'>
                       <MagnifyingGlass 
                        visible={true}
                        height="50"
                        width="50"
                        ariaLabel="MagnifyingGlass-loading"
                        wrapperStyle={{}}
                        wrapperClass="MagnifyingGlass-wrapper"
                        glassColor = '#c0efff'
                        color = '#e15b64'
                        
                        />

<h1 className='Nodata'>No Data Available for selected Year or League</h1>

              

                </div>
       
            ):(<h1></h1>)}
            {loading ? (
               <div class="box">
               <div class="shadow"></div>
               <div class="gravity">
                 <div class="ball"></div>
               </div>
             </div>
            ) : (
                <div className='league-info'>
                    {/* Rest of your code */}
                    <div className='league-info2'>
                        <img className='flag' src={data.flag} alt={`${data.country} Flag`} />
                        <select 
                            name='Select League'
                            id='select-league'
                            defaultValue={selectedLeague}
                            onChange={(e) => setSelectedLeague(e.target.value) }>
                           <option value="39">Premier League</option>
                            <option value="128">Argentine Liga Profesional de Fútbol</option>
                            <option value="71">Brazilian Serie A</option>
                            <option value="169">Chinese Super League</option>
                            <option value="88">Dutch Eredivisie</option>
                            <option value="61">French Ligue 1</option>
                            <option value="78">German Bundesliga</option>
                            <option value="">Indonesian Liga 1</option>
                            <option value="135">Italian Serie A</option>
                            <option value="98">Japanese J Leagues</option>
                            <option value="278">Malaysian Super League</option>
                            <option value="262">Mexican Liga BBVA MX</option>
                            <option value="94">Portuguese Liga</option>
                            <option value="368">Singaporean Premier League</option>
                            <option value="296">Thai Premier League</option>
                            <option value="203">Turkish Super Lig</option>
                            <option value="253">Major League USA</option>

                            <option value="140">La Liga</option>
                            <option value="307">Saudi Pro League</option>
                            <option value="323">ISL</option>

                        </select>

                        <select 
                            name='Select Year'
                            id='select-year'
                            defaultValue={selectedYear}
                            onChange={(e) => setSelectedYear(e.target.value) }>

                                    <option value="2010">2010</option>
                                    <option value="2011">2011</option>
                                    <option value="2012">2012</option>
                                    <option value="2013">2013</option>
                                    <option value="2014">2014</option>
                                    <option value="2015">2015</option>
                                    <option value="2016">2016</option>
                                    <option value="2017">2017</option>
                                    <option value="2018">2018</option>
                                    <option value="2019">2019</option>
                                    <option value="2020">2020</option>
                                    <option value="2021">2021</option>
                                    <option value="2022">2022</option>
                                    <option value="2023">2023</option>

                            </select>

                        <p className='country'>{data.country}</p> 
                      

                     

                       
                    



                        <img className='leaguelogo' src={data.logo} alt={`${data.name} Logo`} />
                    </div>

                    <div className='table'>
                        <p></p> 
                        <p className='rank'>Rank</p> 
                        <p className='placename'>Name</p>
                        <p className='formplace'>Form</p> 
                        <p className='tablePoints'>PTS</p>
                        <p>P </p>
                        <p>W</p>
                        <p>D </p>
                        <p>L</p>
                        <p>GD</p>
                        <p className='tablegf'>GF</p>
                        <p className='tablega'>GA</p>
                    </div>

                    {data.standings[0].map((teamData, index) => (
                        <div key={index} className='standingsdata'>
                            <img src={teamData.team.logo} alt={`${data.country} Flag`} />
                            <p>{teamData.rank}</p> 
                            <p className='teamname'>{teamData.team.name}</p>
                            <p className='form'>{teamData.form}</p> 
                            <p>{teamData.points}</p>
                            <p>{teamData.all.played}</p>
                            <p>{teamData.all.win}</p>
                            <p>{teamData.all.draw}</p>
                            <p>{teamData.all.lose}</p>
                            <p className='gd'>{teamData.goalsDiff}</p>
                            <p className='gf'>{teamData.all.goals.for}</p>
                            <p className='ga'>{teamData.all.goals.against}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Standings;
